// src/pages/ContactoPage.tsx
import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import ContactForm from '../components/ContactForm';
import SEO from '../components/SEO';

const ContactoPage: React.FC = () => {
  return (
    <>
      <SEO
        title="Contacto | Algorithmia - Desarrollo de Software en Córdoba"
        description="Ponte en contacto con Algorithmia. Estamos en Córdoba, Argentina, listos para transformar tus ideas en soluciones digitales. Expertos en software a medida, PWA y automatización."
        keywords="contacto algorithmia, desarrollo software córdoba, consultoría tecnológica argentina, email, teléfono"
        url="https://algorithmia.com.ar/contacto"
        canonicalUrl="https://algorithmia.com.ar/contacto"  // ✅ agregado
        noIndex={true}                                       // ✅ agregado: no indexar /contacto
      />
      
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
        <Header isSplashLoading={false} />

        <section className="pt-32 pb-16 px-4">
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-12"
            >
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Contáctanos</h1>
              <p className="text-xl text-gray-600">
                Estamos en <strong>Córdoba, Argentina</strong>, listos para escuchar tu proyecto.
              </p>
            </motion.div>
            
            <ContactForm onClose={() => {}} />
          </div>
        </section>

        <footer className="py-8 bg-white border-t border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <p className="text-gray-600 text-sm">
              © {new Date().getFullYear()} Algorithmia. Todos los derechos reservados.
            </p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ContactoPage;
